import React from 'react';
import LevelResultTimelineDot from 'src/views/common/Problems/LevelResultTimelineDot';
import { useSelector } from 'react-redux';

export default function StudentLevelResultTimelineDot({ problemsForLevel, end }) {
    const clientProblems = useSelector(state => state.common.clientProblems.filter(cp => problemsForLevel.map(p => p.id).includes(cp.problemId)));
    return (
        <LevelResultTimelineDot clientProblems={clientProblems} problemsForLevel={problemsForLevel} isLastOne={end}/>
    );
}